import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import drop_horz from '../assets/images/drop_horz.svg';
import config from '../config/config';
import ConfirmModalPost from './ConfirmModalPost';
import msgload from '../assets/images/ds.gif';
const PostDropdown = ({ postId, userName, userId, authUser }) => {
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('');
  const [showSaveToListModal, setShowSaveToListModal] = useState(false);
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [userLists, setUserLists] = useState([]);
  const [checkedLists, setCheckedLists] = useState(new Set());
  const [listName, setListName] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [apiResponseMessage, setApiResponseMessage] = useState('');
  const [selectedReportReason, setSelectedReportReason] = useState('');
  const [reportReason, setReportReason] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  // Add this line

  const reportReasons = [
     "I don't like this user's posts",
    'Violates OnlyFans Terms of Service',
    'Contains copyrighted material (DMCA)',
    'Child Sexual Abuse Material (CSAM)',
    'Report Spam',
    'Report Abuse'
  ];

  const showToast = (message, type) => {
    setToastMessage(message);
    setToastType(type);
    setTimeout(() => {
      setToastMessage('');
      setToastType('');
    }, 5000);
  };

  const copyLinkToPost = async () => {
    const postLink = `${window.location.origin}/${postId}/${userName}`;
    try {
      await navigator.clipboard.writeText(postLink);
      showToast('Link copied to clipboard!', 'success');
    } catch (error) {
      showToast('Failed to copy link. Please try again.', 'error');
    }
  };


const handleDeletePost = async () => {
  try {
    const token = localStorage.getItem('token');
    await axios.post(`${config.baseURL}/delete-post`, { post_id: postId }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Reload the page after successful post deletion
    window.location.reload();
  } catch (error) {
    console.error('Failed to delete the post. Please try again.');
  } finally {
    setShowModal(false); // Close the modal
  }
};

const handleCancelDelete = () => {
  setShowModal(false);
};

const dislikePost = async () => {
  try {
    const token = localStorage.getItem('token');
    await axios.post(`${config.baseURL}/dislike-post`, { post_id: postId }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Reload the page after successful dislike
    window.location.reload();
  } catch (error) {
    console.error('Failed to dislike the post. Please try again.');
  }
};

  const hideUserPosts = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${config.baseURL}/hide-users-post`, { hidden_user_id: userId }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      showToast('User\'s posts hidden successfully!', 'success');

      // Reload the page after 2 seconds
      window.location.reload();

    } catch (error) {
      showToast('Failed to hide user\'s posts. Please try again.', 'error');
    }
  };


  const fetchUserLists = async () => {
    setIsLoading(true);  // Start loading
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${config.baseURL}/get-users-list`, {
         headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // Ensure Content-Type is set if necessary
        },
      });
  
      if (response.data.success) {
        setUserLists(response.data.data);
  
        // Update checkedLists state based on the current user being in any of the lists
        const newCheckedLists = new Set();
        response.data.data.forEach(list => {
          // Check if the current user (e.g., userId) is in the list
          const userInList = list.users.some(user => user.id === userId);
          if (userInList) {
            newCheckedLists.add(list.id);
          }
        });
        setCheckedLists(newCheckedLists); // Set the checked lists
      } else {
        showToast('Failed to fetch user lists. Please try again.', 'error');
      }
    } catch (error) {
      showToast('Failed to fetch user lists. Please try again.', 'error');
    } finally {
      setIsLoading(false);  // Stop loading
    }
  };
  

  const handleCheckboxChange = async (listId, userId, isChecked) => {
    setIsLoading(true);  // Start loading
    try {
      const endpoint = isChecked
        ? `${config.baseURL}/add-user-to-list`  // Add user to the list
        : `${config.baseURL}/remove-user-from-list`; // Remove user from the list
  
      const formData = new URLSearchParams();
  
      if (isChecked) {
        formData.append('user_list_id', listId);  
        formData.append('listed_user_id', userId);
      } else {
        formData.append('user_id', userId);  
        formData.append('list_id', listId);
      }
  
      const token = localStorage.getItem('token');
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${token}`
      };
  
      await axios.post(endpoint, formData, { headers });
  
      // Update checkedLists state after the API call
      setCheckedLists(prev => {
        const updated = new Set(prev);
        if (isChecked) {
          updated.add(listId);  // Add listId if checked
        } else {
          updated.delete(listId);  // Remove listId if unchecked
        }
        return updated;
      });
  
      // Now update the userLists state (fetch fresh data or manipulate the list locally)
      setUserLists(prevLists => {
        return prevLists.map(list => {
          if (list.id === listId) {
            // Update user count based on whether the user is checked
            const updatedUserCount = isChecked ? list.user_count + 1 : list.user_count - 1;
            return {
              ...list,
              user_count: updatedUserCount
            };
          }
          return list;
        });
      });
    } catch (error) {
      console.error('Error updating user list:', error);
    } finally {
      setIsLoading(false);  // Stop loading
      await fetchUserLists();  // Re-fetch the lists and ensure the data is up to date

    }
  };
  
  
  



  const handleCreateListSubmit = async (e) => {
    e.preventDefault();
    try {
      if (listName.trim() === "") {
        setErrorMessage("List name cannot be empty");
        setTimeout(() => setErrorMessage(""), 2000);
        return;
      }
      if (listName.length > 64) {
        setErrorMessage("List name cannot exceed 64 characters");
        setTimeout(() => setErrorMessage(""), 2000);
        return;
      }
  
      const token = localStorage.getItem("token");
      const response = await fetch(`${config.baseURL}/create-user-list`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ title: listName }),
      });
  
      const data = await response.json();
  
      if (data.success) {
        setToastMessage(data.message);
        setTimeout(() => setToastMessage(""), 2000);
        setShowCreateListModal(false);
        setListName("");
        setWordCount(0);
        
        // Refresh the user lists to include the newly created list
        await fetchUserLists();
      } else {
        setErrorMessage(data.message);
        setTimeout(() => setErrorMessage(""), 2000);
      }
    } catch (error) {
      setErrorMessage("Error creating list");
      setTimeout(() => setErrorMessage(""), 2000);
    }
  };

  const isAuthenticated = !!localStorage.getItem('token');

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseURL}/report-user`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          report_to: userId, // Make sure userId is correctly set
          reason: selectedReportReason
        })
      });
      const data = await response.json();
      if (data.success) {
        showToast('User reported successfully!', 'success');
        setErrorMessage('');
      } else {
        showToast(data.message || 'Failed to report user', 'error');
      }
    } catch (error) {
      showToast('Error reporting user', 'error');
    } finally {
      setShowReportModal(false);
    }
  };

  return (
    <div className="post-dropdown-container">
      {toastMessage && (
        <div className={`toastmessage ${toastType} ${toastMessage ? 'show' : ''}`}>
          {toastMessage}
        </div>
      )}
      <div className="head_dropdown post_dropdown">
        <ul>
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle"
              id={`productsDropdown-${postId}`}
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img className="icon_dropdown" src={drop_horz} alt="" />
            </Link>
            <ul className="dropdown-menu" aria-labelledby={`productsDropdown-${postId}`}>
              <li className="dropdown">
                <Link className="dropdown-item" onClick={copyLinkToPost}>
                  Copy link to post
                </Link>
              </li>
              {!authUser && (
                <>
                  <li className="dropdown">
                    <a className="dropdown-item" onClick={() => { setShowSaveToListModal(true); fetchUserLists(); }}>
                      Add to / remove from lists
                    </a>
                  </li>
                  <hr className="dropdown-divider" />
                  <li className="dropdown">
                    <Link className="dropdown-item danger_link" onClick={dislikePost}>
                      I don't like this post
                    </Link>
                  </li>
                  <li className="dropdown">
                    <Link className="dropdown-item danger_link" onClick={hideUserPosts}>
                      Hide user's posts from feed
                    </Link>
                  </li>
                  <li className="dropdown">
                    <a className="dropdown-item" onClick={() => setShowReportModal(true)}>
                      Report
                    </a>
                  </li>
                </>
              )}
                {authUser && (
                <li className="dropdown">
                  <Link 
                    className="dropdown-item danger_link" 
                    onClick={() => setShowModal(true)} // Show modal when delete is clicked
                  >
                    Delete Post
                  </Link>
                </li>
              )}              
            </ul>
          </li>
        </ul>


        <ConfirmModalPost 
          show={showModal} 
          onConfirm={handleDeletePost} 
          onCancel={handleCancelDelete} 
        />

      </div>

      {/* Save to List Modal */}
      {showSaveToListModal && (
        <>
          <div className="modal-overlay-dark" onClick={() => setShowSaveToListModal(false)}></div>
          <div className="modal fade show save_list_popup" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1" role="dialog" aria-labelledby="saveToListModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="saveToListModalLabel">SAVE TO LIST</h5>
                  <button type="button" className="btn-close" onClick={() => setShowSaveToListModal(false)} aria-label="Close"></button>
                </div>
              <div className="modal-body">
              {isLoading ? (
  <div className="loading-container">
     <img src={msgload} alt="Loading..." />
  </div>
) : (
  <ul>
    {userLists.map(list => (
      <li key={list.id}>
        <div className="list_wrap_popup">
          <div className="m-checkbox-row checkbox_table">
            <input
              type="checkbox"
              checked={checkedLists.has(list.id)}
              onChange={(e) => handleCheckboxChange(list.id, userId, e.target.checked)}
              name=""
              id={`checkbox-${list.id}`}
            />
            <label htmlFor={`checkbox-${list.id}`} className="g-input__wrapper"></label>
          </div>
          <div className="list_popup">
            <div className="list_popup_left">
              <span>{list.title}</span>
              <small>{list.user_count} user{list.user_count > 1 ? 's' : ''}</small>
            </div>
            <div className="list_popup_right">
              {list.users && list.users.length > 0 ? (
                list.users.map(user => (
                  user.profile_image && (
                    <img
                      key={user.id}
                      src={user.profile_image}
                      alt={user.name}
                      style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                    />
                  )
                ))
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </li>
    ))}
  </ul>
)}

          </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary cancel_btn" onClick={() => setShowCreateListModal(true)}>
                  <svg
                        enableBackground="new 0 0 50 50"
                        height="20px"
                        id="Layer_1"
                        version="1.1"
                        viewBox="0 0 50 50"
                        width="20px"
                        xmlSpace="preserve"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect fill="none" height={20} width={20} />
                        <line
                          fill="none"
                          stroke="#00aff0"
                          strokeMiterlimit={10}
                          strokeWidth={4}
                          x1={9}
                          x2={41}
                          y1={25}
                          y2={25}
                        />
                        <line
                          fill="none"
                          stroke="#00aff0"
                          strokeMiterlimit={10}
                          strokeWidth={4}
                          x1={25}
                          x2={25}
                          y1={9}
                          y2={41}
                        />
                      </svg>
                  New list</button>
                  <button type="button" className="btn btn-secondary cancel_btn" onClick={() => setShowSaveToListModal(false)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}


      {/* Create New List Modal */}
      {showCreateListModal && (
        <>
          <div className="modal-overlay-dark" onClick={() => setShowCreateListModal(false)}></div>
          <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1" role="dialog" aria-labelledby="createNewListModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="createNewListModalLabel">CREATE NEW LIST</h5>
                  <button type="button" className="btn-close" onClick={() => setShowCreateListModal(false)} aria-label="Close"></button>
                </div>
                <form onSubmit={handleCreateListSubmit}>
                  <div className="modal-body">
                    <div className="form-group">
                      <label htmlFor="list-name">List Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="list-name"
                        value={listName}
                        onChange={(e) => {
                          setListName(e.target.value);
                          setWordCount(e.target.value.length);
                        }}
                        maxLength="64"
                      />
                      <small className="form-text text-muted">
                        Word Count: {wordCount} / 64
                      </small>
                      {errorMessage && <div className="alert alert-danger mt-2">{errorMessage}</div>}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary send_btn" onClick={() => setShowCreateListModal(false)}>Cancel</button>
                    <button type="submit" className="btn btn-primary send_btn">Save</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Report Modal */}
      {showReportModal && (
        <>
          <div className="modal-overlay-dark" onClick={() => setShowReportModal(false)}></div>
          <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1" role="dialog" aria-labelledby="reportModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="reportModalLabel">Report Post</h5>
                  <button type="button" className="btn-close" onClick={() => setShowReportModal(false)} aria-label="Close"></button>
                </div>
                <form onSubmit={handleModalSubmit}>
                  <div className="modal-body">
                    <div className="form-group report_lable_box">
                      {reportReasons.map((reason, index) => (
                          <div className="form-check" key={index}>
                            <input 
                              className="form-check-input" 
                              type="radio" 
                              name="reportReason" 
                              id={`reportReason${index}`} 
                              value={reason} 
                              onChange={(e) => setSelectedReportReason(e.target.value)} 
                              required 
                            />
                            <label className="form-check-label" htmlFor={`reportReason${index}`}>
                              {reason}
                            </label>
                          </div>
                        ))}
                      {apiResponseMessage && <div className="alert alert-info mt-2">{apiResponseMessage}</div>}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary send_btn" onClick={() => setShowReportModal(false)}>Cancel</button>
                    <button type="submit" className="btn btn-primary send_btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PostDropdown;
